import './tooltip-styles.css';
export var axisName = '_o5idc51-2-0-1';
export var axisValue = '_o5idc52-2-0-1';
export var duration = '_o5idc53-2-0-1';
export var wrapper = '_o5idc50-2-0-1';